/** Split raw input into individual trimmed, lowercased, non-empty emails. */
export function parseEmails(raw: string): string[] {
  return raw
    .split(/[,;\n]+/)
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean)
}
